<template>
    <seccion-datos :titulo="tipodesistema" @cambios="guardar($data, 'tipoSistema')">
        <div class="form-group">
            <label>{{ $t('general.conexion') }}</label>
            <select class="custom-select form-control-sm" v-model="sistemaSelec">
                <option value="">{{ $t('general.seleccionesistemaconexion') }}</option>
                <option v-for="sistema in listadosistemas" :value="sistema" :key="sistema.id" >{{ sistema.nombre }}</option>
            </select>
        </div>
        <div style="margin: 10px 0" v-if="(sistemaSelec.nombre == 'GENERALI' || sistemaSelec.nombre == 'EUROP_WS' || sistemaSelec.nombre == 'MULTIASISTENCIA_WS') && datos">
            <button class="btn btn-primary btn-sm" @click="abrirRelacionGremios($event)">Gremios relacionados</button>
        </div>
        <OverlayPanel :ref="'gremios_'+datos.idcompañia">
            <div style="max-height: 600px; overflow-y: scroll">
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 5px">
                    <label for="">Especialidad PWGS</label>
                    <label for="">Gremio {{ sistemaSelec.nombre }}</label>
                </div>
                <div style="margin: 10px 0" v-for="especialidad in especialidades" :key="especialidad.idespecialidad">
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 5px">
                        <div>{{ especialidad.nombre }}</div>
                        <div>
                            <select @change="cambioGremioRelacionado(especialidad.idespecialidad)" v-model="relacion_gremios[especialidad.idespecialidad]" class="form-control form-control-sm">
                                <option value="">Seleccionar gremio</option>
                                <option v-for="gremio in gremios" :key="gremio.id" :value="gremio.id">{{ gremio.nombre }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </OverlayPanel>
        <!-- Inicio Opciones sistema -->
            <div v-if="mostrarSelec">
                <h5>{{ $t('general.opcionesdeconexion') }}</h5>
                <!-- Inicio Opciones web -->
                <div v-if="sistemaSelec.configuracion?.campos">
                    <div class="row" v-for="[id, datos] in Object.entries(sistemaSelec.configuracion?.campos)" :key="id">                        
                        <div class="col-md-12">
                            <div class="card card-info card-outline">   
                                <div class="card-header">
                                    <h6 class="card-title">{{id}}</h6>
                                </div>                                                           
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4" v-for="[id2, dato] in Object.entries(datos)" :key="id2">
                                            <div class="form-group">
                                                <label>{{ dato.etiqueta }}</label>
                                                <input :type="dato.etiqueta.includes('Clave') || dato.etiqueta.includes('Secreto')?'password':'text'" class="form-control form-control-sm" :placeholder="dato.descripcion" v-model="dato.valor">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </seccion-datos>
</template>
<script>
import $ from 'jquery';
import { PwgsApi } from '../../../../../services/PwgsApi';
import OverlayPanel from 'primevue/overlaypanel';
export default {
    props: {
        datos: {
            type: Object
        },
    },
    components: {
        OverlayPanel
    },
    inject: ['guardar'],
    data() {
        return{
            relacion_gremios: [],
            gremios: [],
            especialidades: [],
            sistema_compannia: null,
            codigo_usuario_companyia: null,
            codigo_clave_companyia: null,
            correo_colaborador_pap: null,
            correo_pass_colaborador_pap: null,
            servidor_correo_colaborador_pap: null,
            usuario_web: null, 
            clave_web: null, 
            tipodesistema: 'Tipo de sistema',
            sistemaSelec:'',
            mostrarSelec:false,
            listadosistemas:[],
            validarguardar:false,
        }
    },
    computed: {
        sinSistema() {
            return this.sistema_compannia === '' 
                    ||
                   this.sistema_compannia === 'ninguno';
        },
        correos() {
            let aux = this.$store.getters['datosApp/correos'];
            return aux.datos;
        }
    },
    watch: {
        datos() {
            this.init();
            this.cargarsistemas();

        },
        sistemaSelec(value){
            value == ''?this.mostrarSelec=false:this.mostrarSelec=true;
            this.obtenerEspecialidades();
        },
        id() {
            this.init();
            this.cargarsistemas();

        }
    },
    methods: {
        async cambioGremioRelacionado(especialidad){
            const api = new PwgsApi();
            try{
                await api.put('cambio-gremio-especialidad', {sistema:this.sistemaSelec.nombre, especialidad:especialidad, gremio:this.relacion_gremios[especialidad]});
            }catch(error){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo cambiar el gremio', life: 5000 });
            }  
        },
        abrirRelacionGremios(event) {
            var id = 'gremios_'+this.datos.idcompañia;
            console.log('abrir', this.$refs[id], event, id);
            this.$refs[id].toggle(event);
        },
        init() {
            if (this.datos) {
                for (let dato in this.$data) {
                    if (this.datos[dato] !== null && this.datos[dato] !== undefined) {
                        this[dato] = this.datos[dato];
                    }
                }
            }
            const componente = this;
            $(function() {
                const $select = $('.select2');
                $select.select2({
                    theme: 'bootstrap4'
                }).select2('val', this.sistema_compannia);
                $select.on('select2:select', function(e) {
                    var data = e.params.data;
                    componente.sistema_compannia = data.id;
                });
            });
            this.tipodesistema = this.$t('general.tipodesistema');
        },
        async cargarsistemas() {
            //GET  modulos/pwgsapi/index.php/sistemas/estado
            this.sistemaSelec = '';
            const api = new PwgsApi();
            let aux = await api.get('sistemas/'+this.datos.idcompañia);
            this.listadosistemas = aux.datos;
            this.listadosistemas.map(sistema => {if(sistema.nombre == 'KLIVAL')  sistema.nombre= 'RNET-EMAIL'});
            this.listadosistemas.sort((a, b) => a.nombre.localeCompare(b.nombre));
            var sistact = this.datos.sistema_compannia;
            if(sistact == 'KLIVAL') sistact = 'RNET-EMAIL';
            var encontrado = this.listadosistemas.find(sistema => sistema.nombre == sistact);
            console.log("encontrado", encontrado);
            if(encontrado != undefined){
                this.sistemaSelec = encontrado;

            }
        },
        async obtenerEspecialidades() {
            this.gremios = [];
            this.relacion_gremios = {};
            //GET /pwgsapi/index.php/especialidades
            const api = new PwgsApi();
            if(this.sistemaSelec.nombre == 'GENERALI'){
                let aux = await api.get('especialidades');
                this.especialidades = aux.datos;
                let rel = await api.get('relacion-gremios-generali');
                if(!rel){
                    this.relacion_gremios = {};
                }else{
                    this.relacion_gremios = rel;
                }
                this.especialidades.forEach(especialidad => {
                    if(!this.relacion_gremios[especialidad.idespecialidad]){
                        this.relacion_gremios[especialidad.idespecialidad] = '';
                    }
                })
                this.gremios = [
                    {id:'AL', nombre:'Albañilería'},
                    {id:'CA', nombre:'Carpintería'},
                    {id:'CE', nombre:'Cerrajería'},
                    {id:'EL', nombre:'Electricidad'},
                    {id:'FO', nombre:'Fontanería'},
                    {id:'PI', nombre:'Pintura'},
                    {id:'PQ', nombre:'Parqué'},
                    {id:'PO', nombre:'Pocería/Desatranco'},
                    {id:'OT', nombre:'Otros Gremios Especialistas'},
                ]
            }else if(this.sistemaSelec.nombre == 'EUROP_WS'){
                let aux = await api.get('especialidades');
                this.especialidades = aux.datos;
                let rel = await api.get('relacion-gremios-europ');
                if(!rel){
                    this.relacion_gremios = {};
                }else{
                    this.relacion_gremios = rel;
                }
                this.especialidades.forEach(especialidad => {
                    if(!this.relacion_gremios[especialidad.idespecialidad]){
                        this.relacion_gremios[especialidad.idespecialidad] = '';
                    }
                })
                this.gremios = [
                    {id:61, nombre:'Fontanería'},
                    {id:62, nombre:'Albañilería'},
                    {id:63, nombre:'Pintura'},
                    {id:64, nombre:'Electricidad'},
                    {id:65, nombre:'Parqué'},
                    {id:66, nombre:'Carpintería'},
                    {id:67, nombre:'Cerrajería'},
                    {id:68, nombre:'Cristalería'},
                    {id:69, nombre:'Calefacción'},
                    {id:70, nombre:'Ebanistería'},
                    {id:71, nombre:'Escayolista'},
                    {id:72, nombre:'Persianista'},
                    {id:73, nombre:'Enmoquetador'},
                    {id:74, nombre:'Tapicero'},
                    {id:75, nombre:'Carpintería Metalica'},
                    {id:76, nombre:'Marmolista'},
                    {id:77, nombre:'Instalador Sintasol'},
                    {id:78, nombre:'Deshollinador'},
                ]
                //console.log('espec', this.especialidades, this.relacion_gremios);
            }else if(this.sistemaSelec.nombre == 'MULTIASISTENCIA_WS'){
                let aux = await api.get('especialidades');
                this.especialidades = aux.datos;
                let rel = await api.get('relacion-gremios-multiasistencia');
                if(!rel){
                    this.relacion_gremios = {};
                }else{
                    this.relacion_gremios = rel;
                }
                this.especialidades.forEach(especialidad => {
                    if(!this.relacion_gremios[especialidad.idespecialidad]){
                        this.relacion_gremios[especialidad.idespecialidad] = '';
                    }
                })
                let aux2 = await api.get('especialidades/0/multiasistencia');
                let especialidades_multiasistencia = aux2.datos;
                // Construimos el array completo de una sola vez para mantener la reactividad
                const gremiosTemp = [{ id: '', nombre: '' }];
                especialidades_multiasistencia.forEach(item => {
                    gremiosTemp.push({
                        id: item.gremio_servicio,
                        nombre: item.gremio_servicio
                    });
                });
                this.gremios = gremiosTemp;
            }
            let relResponse = await api.get('relacion-gremios-multiasistencia');
            console.log('relResponse', relResponse);
        },
    },
    created() {
        this.init();
    },
    mounted() {
        this.cargarsistemas();
    }
}
</script>